import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EdmundsCarmaxDisclaimer } from 'site-modules/shared/components/appraisal/edmunds-carmax-disclaimer/edmunds-carmax-disclaimer';

export function AppraisalReportDisclaimer({ className = '', isEdmundsLink = false, agreementLinkClassName = '' }) {
  return (
    <div className={classnames('appraisal-report-disclaimer', className)}>
      <div className="mb-1">
        We use data from a wide variety of sources to provide you with your Edmunds appraisal report, considering
        factors such as the car&apos;s year, make, model, trim, mileage, depreciation and features.{' '}
        <span>This is not a firm offer on your car.</span>
      </div>
      <div>
        <EdmundsCarmaxDisclaimer isEdmundsLink={isEdmundsLink} agreementLinkClassName={agreementLinkClassName} />
      </div>
    </div>
  );
}

AppraisalReportDisclaimer.propTypes = {
  className: PropTypes.string,
  isEdmundsLink: PropTypes.bool,
  agreementLinkClassName: PropTypes.string,
};
